import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import mixin from "./mixin";
import LoaderPlugin from './plugins/loaderPlugin';
import { FontAwesomeIcon } from "./plugins/font-awesome";
createApp(App).use(store).use(router).use(LoaderPlugin).mixin(mixin).component("font-awesome-icon", FontAwesomeIcon).mount('#app')